export default {
  DEF_FAQ_CATE_ITEM: {
    typeName: '',
    typeIcon: [],
    questionCount: 0,
  },
};
